import {
  TranslationOutlined,
  ScissorOutlined,
  BgColorsOutlined,
  ExpandOutlined,
  RedoOutlined,
  DeleteOutlined,
} from '@ant-design/icons-vue';

export const menuItems = [
  {
    key: 'translate',
    label: '图片翻译',
    icon: TranslationOutlined,
    disabled: false,
  },
  {
    key: 'backgroundRemove',
    label: '去背景',
    icon: DeleteOutlined,
    disabled: false,
  },
  {
    key: 'textRemove',
    label: '去文字',
    icon: DeleteOutlined,
    disabled: false,
  },
  // {
  //   key: 'crop',
  //   label: '裁剪图片',
  //   icon: ScissorOutlined,
  //   disabled: false,
  // },
  // {
  //   key: 'color',
  //   label: '调整颜色',
  //   icon: BgColorsOutlined,
  //   disabled: true, // 预留功能，暂时禁用
  // },
  // {
  //   key: 'resize',
  //   label: '调整尺寸',
  //   icon: ExpandOutlined,
  //   disabled: true, // 预留功能，暂时禁用
  // },
  // {
  //   key: 'rotate',
  //   label: '旋转图片',
  //   icon: RedoOutlined,
  //   disabled: true, // 预留功能，暂时禁用
  // },
];
